// ENG-1842: alert rows expire out of DynamoDB after ~60 days; older ranges are
// served as an asynchronously generated CSV report from the Athena mirror, and
// their media (frames at 14 days, MP4s to Deep Archive at 60) is gone. This
// mirrors monitoring-api's `is_archived_range` gate so the UI can explain an
// empty grid and steer the user to the report download instead.

// Must agree with monitoring-api's DDB_ALERT_RETENTION_DAYS (env-tunable,
// default 60, monitoring/settings.py) — the backend gate AND the customer-facing
// sentence in the notice both derive from this number. If the backend value ever
// changes, change this with it (or better: have the list response expose the
// horizon and drop this constant).
export const ALERT_RETENTION_DAYS = 60;

export const isArchivedRange = (
  startDate: Date | string | null | undefined
): boolean => {
  if (!startDate) {
    // No explicit start date = the default recent view; never archived.
    return false;
  }
  const start =
    startDate instanceof Date
      ? startDate
      : new Date(`${String(startDate).slice(0, 10)}T00:00:00`);
  if (isNaN(start.getTime())) {
    return false;
  }
  const horizon = new Date();
  horizon.setHours(0, 0, 0, 0);
  horizon.setDate(horizon.getDate() - (ALERT_RETENTION_DAYS - 1));
  return start < horizon;
};
